import { Container, Grid2 } from '@mui/material';
import { navigate } from 'gatsby';
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import BackgroundIcon from '@components/BackgroundIcon';
import MainTitle from '@components/MainTitle';
import RoundedButton from '@components/RoundedButton';
import { ShareButton } from '@components/ShareButton';

import * as ROUTES from '@constants/routes';

import { useSession } from '@hooks/useSession';

import AppLayout from '@layouts/AppLayout';
import { MainContainer } from '@layouts/Layouts/TableLayout';

import Main from '@views/HealthSummary/Main/AuthMain';

import { ShareType } from 'generated/types';

const messages = defineMessages({
  title: {
    id: 'healthSummary.title',
    defaultMessage: 'Health Summary',
  },
  exportPdf: {
    id: 'healthSummary.exportPdf',
    defaultMessage: 'Export PDF',
  },
});

export default function HealthSummaryPage() {
  const { formatMessage } = useIntl();
  const {
    state: { activeProfile },
  } = useSession();
  const vitall_patient_id = activeProfile?.vitall_patient_id ?? '';

  const handleExportPdf = () => {
    void navigate(ROUTES.HEALTH_SUMMARY_PRINT);
  };

  return (
    <AppLayout friendlyName={formatMessage(messages.title)} showHeader>
      <MainContainer>
        <BackgroundIcon />

        <Container maxWidth="lg">
          <Grid2 alignItems="center" container justifyContent={'space-between'}>
            <Grid2 size={{ xs: 8 }}>
              <MainTitle title={formatMessage(messages.title)} />
            </Grid2>
            <Grid2
              size={{ xs: 4 }}
              sx={{
                textAlign: 'right',
                display: 'flex',
                justifyContent: 'flex-end',
                gap: 1,
                alignItems: 'center',
              }}
            >
              <RoundedButton autoSize onClick={handleExportPdf} variant="blue">
                {formatMessage(messages.exportPdf)}
              </RoundedButton>
              <ShareButton
                color="primary.main"
                share_type={ShareType.HealthSummary}
                vitall_patient_id={vitall_patient_id}
              />
            </Grid2>
          </Grid2>

          <Main />
        </Container>
      </MainContainer>
    </AppLayout>
  );
}
